import { setToken } from '../../helper/token';
import apiManager from '../../utils/apiManager';
import { axiosConfigEvent } from '../../utils/events';
import AuthApis from '../Login/configs/auth.apis';

class AuthServices {
  /** Verify OTP */
  static async verifyLoginOtp(otp: string, verificationString: string) {
    try {
      const res = await apiManager.post(AuthApis.verifyOtp, {
        verification_string: verificationString,
        otp: otp,
      });
      if (res?.data?.access) {
        setToken(res.data.access, res.data.refresh);
        axiosConfigEvent.refreshConfig();

        return res.data.access;
      }
    } catch (error) {}
    return '';
  }
}

export default AuthServices;
